<template>
  <div v-if="contractUpdates && contractUpdates.length > 0">
    <div
      v-for="(update, index) in contractUpdates"
      :key="update.id || index"
      class="relative bg-white rounded-2xl shadow-md p-6 mx-auto mb-4"
    >
      <h3 class="text-lg font-semibold mb-4">Changement de formule</h3>
      <div class="space-y-2">
        <FieldRow label="Formule" :value="update.title" />
        <FieldRow label="Offre" :value="update.category" />
        <FieldRow label="Prix" :value="price(update)" />
        <FieldRow label="Date" :value="formatAnalyticsDate(update.createdAt, 'dd/MM/yyyy')" />
        <FieldRow v-if="formulaChangeLetter" label="Courrier">
          <CopyToClipboard :textToCopy="formulaChangeLetter">
            <span class="cursor-pointer text-primary hover:text-primary-dark font-light">Lien</span>
          </CopyToClipboard>
        </FieldRow>
      </div>
    </div>
  </div>
  <div v-else class="text-center text-gray-500 p-6">Aucune mise à jour de contrat disponible</div>
</template>

<script>
import { CopyToClipboard, FieldRow, formatPrice } from "@estaly/ui";
import { formatAnalyticsDate } from "@/utils/date_formatter";

export default {
  components: {
    FieldRow,
    CopyToClipboard,
  },

  props: {
    contractUpdates: {
      type: Array,
      required: true,
    },
    formulaChangeLetter: {
      type: String,
      default: null,
    },
  },

  methods: {
    formatAnalyticsDate,
    price(contractUpdate) {
      return `${formatPrice(contractUpdate.price)}${contractUpdate.monthly ? " / mois" : ""}`;
    },
  },
};
</script>
